var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 18.333,
    viewBox: "0 0 16.667 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(-1.667 -0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24569",
    "data-name": "Path 24569",
    d: "M4.167,3.333H15.833A1.667,1.667,0,0,1,17.5,5V16.667a1.667,1.667,0,0,1-1.667,1.667H4.167A1.667,1.667,0,0,1,2.5,16.667V5A1.667,1.667,0,0,1,4.167,3.333Z",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24570",
    "data-name": "Path 24570",
    d: "M13.333,1.667V5",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24571",
    "data-name": "Path 24571",
    d: "M6.667,1.667V5",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24572",
    "data-name": "Path 24572",
    d: "M2.5,8.333h15",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCalendar);
export default __webpack_public_path__ + "static/media/feather_calendar.20fd793c3d03146ef0f8a8231d4ace49.svg";
export { ForwardRef as ReactComponent };